module.exports = __webpack_public_path__ + "assets/img/accomplish.c2434f53.png";